export default {
  quantities: ['1'],
};
